// @flow

import React from 'react';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ApplyOptions from './apply-options';
import asyncComponent from '../util/async-component';
import { IMAGE_PATH } from '../util/config';

const ReactPlayer = asyncComponent(() => import('react-player'));

const styles = theme => ({
  adImageCell: {
    textAlign: 'center',
  },
  tagline: {
    padding: '5px 0',
  },
  adImage: {
    maxWidth: '500px',
    width: '100%',
    marginBottom: '10px',
    marginTop: '10px',
  },
  applyText: {
    fontWeight: 300,
  },
  container: {
    paddingBottom: '20px',
  },
});

type Props = CoreApplyProps & {
  classes: Object,
  job: Job,
  org: Org,
  allowApply: boolean,
  fullScreen: boolean,
}

type State = {
  videoError: boolean,
};

class JobDescription extends React.PureComponent<Props, State> {
  static defaultProps = {
    allowApply: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      videoError: false,
    };
  }

  handleVideoError = () => {
    this.setState({
      videoError: true,
    });
  }

  renderGraphic = () => {
    const { classes, job, fullScreen } = this.props;
    if (job.videoUrl && !this.state.videoError) {
      return (
        <ReactPlayer
          style={{
            margin: 'auto',
            marginBottom: '10px',
            maxWidth: fullScreen ? '240px' : '640px',
            maxHeight: fullScreen ? '160px' : '360px',
          }}
          width="90%"
          url={job.videoUrl}
          controls
          onError={this.handleVideoError}
        />);
    }
    return (
      <img
        src={`${IMAGE_PATH}/${this.props.job.imagePath || ''}`}
        alt={this.props.job.title}
        className={classes.adImage}
      />
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.container}>
        {this.props.job.tagline && this.props.job.imagePath &&
          <Grid item xs={12} className={classes.adImageCell}>
            <Typography variant="subtitle1">
              {this.props.job.tagline}
            </Typography>
            {this.renderGraphic()}
          </Grid>
        }
        {this.props.allowApply &&
        <Grid item xs={12}>
          <ApplyOptions
            jobHash={this.props.job.job_hash}
          />
        </Grid>
        }
        <Grid item xs={12}>
          <Typography variant="subtitle1" className={classes.applyText}>
            {/* eslint-disable-next-line */}
            <div dangerouslySetInnerHTML={{ __html: this.props.job.description }} />
          </Typography>
        </Grid>
        {this.props.allowApply &&
        <Grid item xs={12}>
          <ApplyOptions
            jobHash={this.props.job.job_hash}
          />
        </Grid>
        }
      </Grid>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(JobDescription));
